import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import apiConfig from '../../api/apiConfig';
import axios from 'axios';

const CastList = props => {
    const { category } = useParams();
    const [casts, setCasts] = useState([]);

    useEffect(() => {
        const getCredits = async () => {
            const response = await axios.get(`https://api.themoviedb.org/3/${category}/${props.id}/casts?api_key=088f4df643022cbbe2a297babd84490c`);
            setCasts(response.data.cast.slice(0, 5));
        }
        getCredits();
    }, [category, props.id]);
    
    return (
        <div className='casts'>
            {
                casts.map((cast, index) => (
                    <div className="casts__item" key={index}>
                        <div className="casts__item__img" style={{ backgroundImage: `url(${apiConfig.w500Image(cast.profile_path)})` }}></div>
                        <p className="casts__item__name">{cast.name}</p>
                    </div>
                ))
            }
        </div>
    )
}

export default CastList